import { getUserColor } from "shared/lib/user/getUserColor"
import { getUserInitials } from "shared/lib/user/getUserInitials"
import { User } from "shared/types/__generated__/graphql"
import { TextAvatar } from "shared/ui/text-avatar/TextAvatar"

import "./styles/_team-initials-list.scss"

export interface TeamInitialsListViewProps {
  usersToShow: Pick<User, "id" | "name" | "email">[]
  additionalUserCount: number
}

export function TeamInitialsListView({
  usersToShow,
  additionalUserCount
}: TeamInitialsListViewProps) {
  if (!usersToShow.length) {
    return null
  }

  return (
    <div className="team-initials-list">
      <div className="team-initials-list__initials">
        {usersToShow.reverse().map(user => (
          <TextAvatar
            key={user?.id}
            initials={getUserInitials(user)}
            color={getUserColor(user?.id)}
            className="text-avatar--small"
          />
        ))}
      </div>
      {additionalUserCount > 0 && (
        <div className="team-initials-list__count">+{additionalUserCount}</div>
      )}
    </div>
  )
}
